import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2, Plus } from "lucide-react";

const blank = { name: "", title: "", role: "staff", bio: "", email: "", phone: "", photo_url: "", sort_order: 0 };

export default function AdminLeadership() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(blank);

  const load = () => api.get("/team").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    await api.post("/team", { ...form, sort_order: parseInt(form.sort_order) || 0 });
    setForm(blank);
    load();
  };
  const del = async (id) => { await api.delete(`/team/${id}`); load(); };

  return (
    <div data-testid="admin-team">
      <div className="section-label">People</div>
      <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Board & Staff</h1>

      <div className="mt-8 bg-white border border-slate-200 p-6 rounded-md grid sm:grid-cols-2 gap-3">
        <input data-testid="team-name" placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="team-title" placeholder="Title (e.g., Board Chair)" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <select data-testid="team-role" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="border border-slate-300 px-3 py-2 bg-white">
          <option value="board">Board</option>
          <option value="staff">Staff</option>
        </select>
        <input data-testid="team-order" type="number" placeholder="Sort order" value={form.sort_order} onChange={(e) => setForm({ ...form, sort_order: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="team-email" placeholder="Email (optional)" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="team-phone" placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="team-photo" placeholder="Photo URL (optional)" value={form.photo_url} onChange={(e) => setForm({ ...form, photo_url: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <textarea data-testid="team-bio" placeholder="Bio (optional)" rows={3} value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <button data-testid="team-add" onClick={add} className="bg-slate-950 text-white px-4 py-2 sm:col-span-2 inline-flex items-center gap-2 justify-center"><Plus className="h-4 w-4" /> Add person</button>
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-4">
        {list.map((m) => (
          <div key={m.id} className="bg-white border border-slate-200 p-5 rounded-md">
            <div className="flex justify-between items-start">
              <div>
                <div className="font-display text-lg font-semibold">{m.name}</div>
                <div className="text-xs font-mono uppercase tracking-widest text-sky-600 mt-1">{m.title} · {m.role}</div>
              </div>
              <button data-testid={`team-del-${m.id}`} onClick={() => del(m.id)} className="text-red-600 hover:text-red-800"><Trash2 className="h-4 w-4" /></button>
            </div>
            {m.bio && <p className="text-sm text-slate-600 mt-2">{m.bio}</p>}
            <div className="text-xs font-mono text-slate-500 mt-2">
              {m.email && <div>{m.email}</div>}
              {m.phone && <div>{m.phone}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
